import { Component, ViewChild, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { DialogBoxCambioEstadoComponent } from './dialog/dialog-box-cambio-estado.component';
import { DialogBoxCopiarComponent } from './dialog/dialog-box-copiar.component';
import { DialogBoxPrintComponentAnalisisDeBrechas } from './dialog/dialog-print-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { AnalisisDeBrechasService } from '../../services/analisis-de-brechas.service';
import { AnalisisDeBrechas } from 'app/main/models/analisis-de-brechas.model';
import { TablaDeEvaluacionService } from '../../services/tabla-de-evaluacion.service';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import { MarcoDeReferencia } from 'app/main/models/marco-de-referencia.model';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import {MatTooltipModule} from '@angular/material/tooltip';
import { UsersService } from '../../services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {FormBuilder, FormGroup,FormControl, Validators} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { DialogAnalisisBoxPrintComponentAnalisisDeBrechas} from './dialog/dialog-analisis-print-box.component';
import { DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas} from './dialog/dialog-analisis-analytics-box.component';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector   : 'analisis-de-brechas-view',
    templateUrl: './analisis-de-brechas-view.component.html',
    styleUrls  : ['./analisis-de-brechas-view.component.scss']
})
export class AnalisisDeBrechasViewComponent
{
    displayedColumns: string[] = ['nombre', 'descripcion','respuesta'];
    analisisDeBrechas : AnalisisDeBrechas = null;
    selectedStatus: number;
    isEditable = false;
    isReseted = false;
    
    id :number = null;
    is_eval_creador: boolean = false;
    is_responsable: boolean = false;

    editar_nombre: boolean = false;
    editar_estado: boolean = false;
    editar_tabla_de_evaluacion:boolean = false;
    editar_estructura:boolean = false;
    editar_marco_de_referencia: boolean = false;
    editar_responsable: boolean = false;
    editar_fecha_fin: boolean = false;
    nombre: string = "";

    estados: any[] = ['PRE_INICIADO','COMPLETADO','CERRADO'];

    marcosDeReferencia = [];
    estructuraJerarquicas = [];
    tablasDeEvaluacion = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];

    preiniciadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    iniciadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    completadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    aprobadoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});
    cerradoFormGroup: FormGroup =  new FormGroup({firstName: new FormControl()});

    isThisStepDone0=false;
    isThisStepDone1=false;
    isThisStepDone2=false;
    isStepDone0 = "";
    isStepDone1 = "";
    isStepDone2 = "";

    selectedIndex = null;
    role = null;
    is_eval_owner = false;
    is_admin = false;

    fechaFin = null;
    editar_dueno = true;

    @ViewChild('stepper') private stepper: MatStepper;

    tipo = 'ANALISIS_DE_BRECHAS';

    //@ViewChild("stepper") stepper: MatStepper;


    constructor(public dialog: MatDialog,
                private storage: TokenStorageService,
                private service: AnalisisDeBrechasService,
                public serviceTablasDeEvaluacionService:TablaDeEvaluacionService,
                public serviceMarcoDeReferenciaService:MarcoDeReferenciaService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                public router: Router,
                public utils:UtilsService,
                private route: ActivatedRoute) {}

    ngOnInit() {

      this.route.paramMap.subscribe(params => {
          this.id = parseInt(params.get('id'), 10);

          this.service.get(this.id).pipe().subscribe(req => {
            this.analisisDeBrechas = new AnalisisDeBrechas(req.body);

            this.analisisDeBrechas.marcoDeReferencia.sentencias  = [...this.analisisDeBrechas.marcoDeReferencia.sentencias];
            this.orderStructure(this.analisisDeBrechas.marcoDeReferencia.sentencias);
            this.loadEvalData();
          });
      });

      this.serviceTablasDeEvaluacionService.getAll(this.tipo,0,1000).pipe().subscribe(req => {
        this.tablasDeEvaluacion = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });

      this.serviceMarcoDeReferenciaService.getAll(this.tipo,0,1000).pipe().subscribe(req => {
        this.marcosDeReferencia = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre
          };
        });
      });
      
    }

    loadEvalData(){

      var user = this.storage.getUser();
      this.role = this.storage.getRole();
      this.setActiveStep();

      this.fechaFin = this.analisisDeBrechas.fechaFin;

      if(this.role!=undefined && this.role.includes(2))
        this.is_admin = true;

      if(this.analisisDeBrechas.creador.correoElectronico.trim() == user.trim()){
          this.is_eval_creador = true;
      }

      if(this.analisisDeBrechas.responsable.correoElectronico.trim() == user.trim()){
            this.is_responsable = true;
      }
      console.log(this.analisisDeBrechas?.marcoDeReferencia?.sentencias);

    }

    print():void{

      const dialogRef = this.dialog.open(DialogAnalisisBoxPrintComponentAnalisisDeBrechas, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        data: {action:"Print", obj:this.analisisDeBrechas},
        autoFocus: false,
        disableClose: true
      });

    }

    viewStatistics(sentencias, nivel, esMatrizReverso):void{
      //DialogAnalisisBoxPrintComponentAnalisisDeBrechas
      const dialogRef = this.dialog.open(DialogAnalisisBoxAnalyticsComponentAnalisisDeBrechas, {
        panelClass: 'my-full-screen-dialog',
        width: '95%',
        maxWidth: '95%',
        height: '95%',
        maxHeight: '95%',
        data: {action:"Print", 
              obj:sentencias,
              nivel: nivel,
              tablaDeAnalisisDeBrechas:this.analisisDeBrechas?.tablaDeAnalisisDeBrechas,
              esMultiple: this.analisisDeBrechas?.tablaDeAnalisisDeBrechas.tipo=="EVALUACION_MULTIPLE",
              esMatrizReverso: esMatrizReverso},
        autoFocus: false,
        disableClose: true
      });
      
    }

    navegateTo(url, id): void  {
        this.router.navigateByUrl(url).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openDialog(): void {
      var obj = {ownerSelector:true,tipoUsuario:7};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {

        this.service.editEstructura(this.analisisDeBrechas.id,
          {estructura:result.data.estructura,nodo:result.data.nodo}).pipe().subscribe(req => {
            this.analisisDeBrechas.nodoEstructuraJerarquica = result.data.nodo;
            this.analisisDeBrechas.estructuraJerarquica = result.data.estructura;
            this.analisisDeBrechas.responsable = result.data.usuario;
            this.selectResponsable({value:result.data.usuario});

        },
        err => {
          this.openSnackBar("No se pudo modificar la estructura, ocurrió un error.","Cerrar");
        });

      });
    }

    selectEstado():void{

      this.editar_estado = false;

    }

    selectRespuesta(sentencia,respuesta):void{
      this.service.addRespuesta(sentencia.id,respuesta.value).pipe().subscribe(req => {

      },
      err => {
      this.openSnackBar("No se pudo registrar la respuesta, ocurrió un error.","Cerrar");
      });
    }

    updateName(nombre):void{
      this.editar_nombre = false;

      this.service.editNombre(this.analisisDeBrechas.id,nombre).pipe().subscribe(req => {
        this.analisisDeBrechas.nombre = nombre;
      },
      err => {
      this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
      });
    }

    selectTablaDeEvaluacion(tipo):void{
      this.editar_tabla_de_evaluacion = false;

      this.service.editTablaDeEvaluacion(this.analisisDeBrechas.id,tipo.value).pipe().subscribe(req => {
        this.analisisDeBrechas.tablaDeAnalisisDeBrechas = tipo.value;
        this.openDialog();
      },
      err => {
        this.openSnackBar("No se pudo modificar la tabla de evaluación, ocurrió un error.","Cerrar");
      });
    }


    selectMarcoDeReferencia(escenario):void{
      this.editar_marco_de_referencia = false;

      this.service.editMarcoDeReferencia(this.analisisDeBrechas.id,escenario.value).pipe().subscribe(req => {
        this.analisisDeBrechas.marcoDeReferencia = req.body;
      },
      err => {
        this.openSnackBar("No se pudo modificar el escenario, ocurrió un error.","Cerrar");
      });
    }

    selectResponsable(owner):void{
      this.editar_responsable = false;

      this.service.editResponsable(this.analisisDeBrechas.id,owner.value).pipe().subscribe(req => {
        this.analisisDeBrechas.responsable = owner.value;
      },
      err => {
        this.openSnackBar("No se pudo modificar el responsable, ocurrió un error.","Cerrar");
      });
    }

    selectFechaFin(fecha):void{
      this.editar_fecha_fin = false;
      this.service.editFechaFin(this.analisisDeBrechas.id,fecha.value).pipe().subscribe(req => {
        this.analisisDeBrechas.fechaFin = fecha.value;
      },
      err => {
        this.openSnackBar("No se pudo modificar la fecha de finalización, ocurrió un error.","Cerrar");
      });

    }

    copiar():void{
      const dialogRef = this.dialog.open(DialogBoxCopiarComponent, {
        width: '100%',
        data: {action:'Copiar',obj:this.analisisDeBrechas},
        disableClose: true
      });
    }

    setIndex(event) {
      this.selectedIndex = event.selectedIndex;

    }

    changeStatus():void{

      var ss = this.selectedStatus;
      var status = "";
      if(ss==0 && (this.is_responsable) && this.analisisDeBrechas.estado=="PRE_INICIADO" ){
        status = "COMPLETADO";
      }
      if(ss==1 && this.is_eval_creador && this.analisisDeBrechas.estado=="COMPLETADO"){
        status = "CERRADO";
      }

      if(status!=""){

        const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
          width: '100%',
          data: {action:status},
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result.event != 'Cancel'){
              this.service.editStatus(this.analisisDeBrechas.id,status).pipe().subscribe(req => {
              this.analisisDeBrechas.estado = status;
              this.setActiveStep();
              this.openSnackBar("Se modificó el estado del análisis a "+status,"Cerrar");
            },
            err => {
              this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
            });
          }else{
            this.setActiveStep();
          }
        });

      }

    }

    setActiveStep():void{
      this.isThisStepDone0=false;
      this.isThisStepDone1=false;
      this.isThisStepDone2=false;
      this.isStepDone0 = "";
      this.isStepDone1 = "";
      this.isStepDone2 = "";

      if(this.analisisDeBrechas.estado=="PRE_INICIADO"){
        this.selectedStatus = 0;

      }
      if(this.analisisDeBrechas.estado=="COMPLETADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.selectedStatus = 1;

      }
      if(this.analisisDeBrechas.estado=="CERRADO"){
        this.isThisStepDone0=false;
        this.isStepDone0 = "done";
        this.isThisStepDone1=false;
        this.isStepDone1 = "done";
        this.selectedStatus = 2;

      }

      this.stepper.linear = false;
      this.stepper.selectedIndex = this.selectedStatus;
      setTimeout(() => {
         this.stepper.linear = true;
      });

    }

    rechazar():void{

      const dialogRef = this.dialog.open(DialogBoxCambioEstadoComponent, {
        width: '100%',
        data: {action:"Rechazar"},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event != 'Cancel'){
          this.service.editStatusRechazo(this.analisisDeBrechas.id,"PRE_INICIADO",result.motivo).pipe().subscribe(req => {
            this.analisisDeBrechas.estado = "PRE_INICIADO";
            this.stepper.previous();
            this.setActiveStep();
            this.openSnackBar("Se rechazo el análisis y se cambió el estado a "+status,"Cerrar");
             window.location.reload();
          },
          err => {
            this.openSnackBar("No se pudo modificar el estado, ocurrió un error.","Cerrar");
          });
        }
      });

    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }


    compareObjects(o1: any, o2: any): boolean {
      var equals = false;
      if(o1!=null && o2!=null)
        equals = o1.nombre === o2.nombre && o1.id === o2.id
      return equals;
    }

    esEvaluadorGroup(usuario):boolean{

      var esEvaluador:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 7)
          esEvaluador = true;
      });

      return esEvaluador;
    }

    orderStructure(nodos):void{
        for(var z=0; nodos.length>z;z++){
          nodos.sort(this.utils.sortAlphaNum);
          //nodos.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
          this.orderStructure(nodos[z].sentencias);
        }
      }

      selectDueno(owner):void{
        this.editar_dueno = false;

        this.service.editResponsable(this.analisisDeBrechas.id,owner.value).pipe().subscribe(req => {
          this.analisisDeBrechas.responsable = owner.value;
          this.editar_responsable = false;
          //window.location.reload();
        },
        err => {
          this.openSnackBar("No se pudo modificar el dueño, ocurrió un error.","Cerrar");
        });
      }

      updateData():void{
        this.analisisDeBrechas.marcoDeReferencia.sentencias = [...this.analisisDeBrechas.marcoDeReferencia.sentencias];
      }


}
